<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="stickyCollectionKey" [stickyZ]="stickyZ" [stickyOrder]="0">
    <div class="modal-header no-bottom-border">
      <div class="modal-title mb-28px">Location Display Changes</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div class="edit-collection-save-confirmation-container">
      <div
        libStickyAutoPosition
        [stickyCollectionKey]="stickyCollectionKey"
        [stickyZ]="stickyZ"
        [stickyOrder]="1"
        class="info-text bs-medium bg-white f12px">
        <p>The following changes will be made to the required location displays.</p>
        <hr />
      </div>

      <ng-container *ngIf="viewModel.numberOfProvinces$ | async as numberOfProvinces">
        <app-single-province-location-display-list-items
          *ngIf="numberOfProvinces === 1"
          [collectionIsPublished]="true"
          [originalRequiredDisplayIds]="viewModel.originalRequiredDisplayIds$ | async"
          [updatedRequiredDisplayIds]="viewModel.updatedRequiredDisplayIds$ | async"
          [groupedRequiredDisplays]="viewModel.changedDisplaysGroupedByLocationAndProvince$ | async">
        </app-single-province-location-display-list-items>

        <app-grouped-province-location-display-list-items
          *ngIf="numberOfProvinces > 1"
          [collectionIsPublished]="true"
          [originalRequiredDisplayIds]="viewModel.originalRequiredDisplayIds$ | async"
          [updatedRequiredDisplayIds]="viewModel.updatedRequiredDisplayIds$ | async"
          [groupedRequiredDisplays]="viewModel.changedDisplaysGroupedByLocationAndProvince$ | async">
        </app-grouped-province-location-display-list-items>
      </ng-container>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary ngbAutofocus (buttonClicked)="close(true)"> Save Collection </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
